const ProvidersIcon = ({ color = '#D5DCEB', width = '16', height = '16', ...props }) => (
  <svg width={height} height={width} viewBox="0 0 56 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M39 35L46 38C52 40 55 41.92 55 48V64" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M17 35L10 38C4 40 1 41.92 1 48V64" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M11 56V64" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M45 56V64" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M25 64V37L22 34V28" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M31 64V37L34 34V28" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M21 64V54L15 40L21 39L15 33L18 31L22 30" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M35 64V54L41 40L35 39L41 33L38 31L34 30" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path
      d="M18 15L17 12V7C17 5.34 18.34 4 20 4H21C21 2.34 22.34 1 24 1H35C37.21 1 39 2.79 39 5V12L38 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M36 12V10C36 8.9 35.1 8 34 8V6L30 8H22C20.9 8 20 8.9 20 10V12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M19 19C19 24 21 31 28 31C35 31 37 24 37 19" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path
      d="M36 20H33C31 20 30 17 30 17V16C30 15.45 30.45 15 31 15H38C38.55 15 39 15.45 39 16V17C39 17 38 20 36 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M23 20H20C18 20 17 17 17 17V16C17 15.45 17.45 15 18 15H25C25.55 15 26 15.45 26 16V17C26 17 25 20 23 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M26 17H30" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
)

export default ProvidersIcon
